import "core-js/modules/es6.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import { TransitionMotion, spring } from 'react-motion';

var willEnter = function willEnter() {
  return {
    XPosition: -5,
    opacity: 0
  };
};

var willLeave = function willLeave() {
  return {
    opacity: spring(0)
  };
};

var getStyles = function getStyles() {
  return {
    XPosition: spring(0),
    opacity: spring(1)
  };
};

var MoveRightFadeInFadeOut = function MoveRightFadeInFadeOut(_ref) {
  var children = _ref.children,
      show = _ref.show;
  return /*#__PURE__*/React.createElement(TransitionMotion, {
    willLeave: willLeave,
    willEnter: willEnter,
    styles: show ? [{
      key: 'key',
      style: getStyles(),
      data: children
    }] : []
  }, function (interpolated) {
    return /*#__PURE__*/React.createElement("div", null, interpolated.map(function (_ref2) {
      var key = _ref2.key,
          style = _ref2.style,
          data = _ref2.data;
      return /*#__PURE__*/React.createElement("div", {
        key: "".concat(key, "-transition"),
        style: {
          transform: "translateX(".concat(style.XPosition, "px)"),
          opacity: style.opacity
        }
      }, data);
    }));
  });
};

MoveRightFadeInFadeOut.displayName = 'MoveRightFadeInFadeOut';
MoveRightFadeInFadeOut.propTypes = {
  children: PropTypes.node,
  show: PropTypes.bool.isRequired
};
MoveRightFadeInFadeOut.defaultProps = {
  children: null
};
export default MoveRightFadeInFadeOut;